import React, { useEffect, useRef, useState } from "react";
import Joyride, { EVENTS, Step, TooltipRenderProps } from "react-joyride";
import styles from './fixDataWizard.module.scss';
import Button from "../../../../components/button/Button";
import { emailChecking, nameChecking, typoCheckingDataToClean } from "./bulkUsersImportTable";
import { isNotEmail } from "../../../../utils/validation";

type Props = {
  updateTableDataField: (value: any, rowId: number, columnId: string) => void,
  setTourEnd: (value: boolean) => void,
  dataToClean: typoCheckingDataToClean,
  dataSource: any,
}

let lastElement = "";

// auto scroll method
const scrollToView = (target: string | undefined) => {
  if (target) setTimeout(() => {
    let tableEle = document.getElementById("bulkInviteTable");
    if (lastElement.substring(0, 5) !== target.substring(0, 5) && tableEle) {
      tableEle.scrollTop = 0;
    }
    let y = tableEle?.getBoundingClientRect();
    let y2 = document.getElementsByClassName(`${target.substring(1)}`)[0]?.getBoundingClientRect();
    if (y && y2) {
      let yDif = y2.y - y.y;
      tableEle?.scrollBy(0, yDif);
    }
    lastElement = target;
  }, 100);
}


const EmailValidation = (props: { stepIndex: number, element: emailChecking, fieldName: string, updateTableDataField: any, setJoyDex: any, hello: any, skipStepToStep: (stepIndex: number) => number }) => {
  const {stepIndex, element, updateTableDataField, setJoyDex, hello, skipStepToStep} = props;
  const [value, setValue] = useState<string | undefined>();
  const emailInputValidationRef: any = useRef();

  useEffect(() => {
    if (element) setValue(element.fieldValue);
  }, [element]);

  useEffect(() => {
    setTimeout(() => {
      if (emailInputValidationRef.current) {
        emailInputValidationRef.current.focus();
      }
    }, 40);
  }, []);

  return <div style={{textAlign: "left"}} key={element.rowId}>
    <div style={{marginBottom: 10}}>{stepIndex}. The email <span
      style={{fontWeight: 600}}>{element?.fieldValue}</span> is not a proper email address. Please fix it.
    </div>
    <div>
      <input
        className={styles.input}
        style={{width: "-webkit-fill-available", marginTop: 20}}
        value={value || ""}
        ref={element => (emailInputValidationRef.current = element)}
        onKeyPress={(e) => {
          if (e.key === "Enter" && !isNotEmail(value)) {
            let nextStep = skipStepToStep(stepIndex);
            scrollToView(hello.current[nextStep]?.target);

            setTimeout(() => {
              setJoyDex(nextStep);
              updateTableDataField(value, element.rowId, element.column);
            }, 600);
          }
        }}
        onChange={(e) => setValue(e.target.value)}
        autoFocus
      />

    </div>
    <div className={styles.tooltipFooter}>
      <Button
        disabled={false}
        label={"Skip Lead"}
        title={"Skip and do not invite this lead"}
        color={"green"}
        className={styles.buttonSkip}
        onClick={() => {
          updateTableDataField("No", element.rowId, "invite");
          let nextStep = skipStepToStep(stepIndex);
          scrollToView(hello.current[nextStep]?.target);
          setTimeout(() => {
            setJoyDex(nextStep);
          }, 600);
        }}
      />
      <Button
        disabled={isNotEmail(value)}
        label={`Continue`}
        title={`Click or press the "Enter Key"`}
        className={styles.buttonContinue}
        onClick={() => {
          let nextStep = skipStepToStep(stepIndex);
          scrollToView(hello.current[nextStep]?.target);

          setTimeout(() => {
            setJoyDex(nextStep);
            updateTableDataField(value, element.rowId, element.column);
          }, 600);
        }}
      />
    </div>
  </div>
}

const BlankNames = (props: { stepIndex: number, element: nameChecking, fieldName: string, updateTableDataField: any, setJoyDex: any, hello: any, skipStepToStep: (stepIndex: number) => number }) => {
  const {stepIndex, element, fieldName, updateTableDataField, setJoyDex, hello, skipStepToStep} = props;
  const [value, setValue] = useState<string>("");
  const blankNamesInputValidationRef: any = useRef();

  useEffect(() => {
    if (element) setValue(element.fieldValue);
  }, [element]);

  useEffect(() => {
    setTimeout(() => {
      blankNamesInputValidationRef.current.focus()
    }, 40);
  }, []);

  return <div style={{textAlign: "left"}} key={element.rowId}>
    <div style={{marginBottom: 10}}>{stepIndex}. {fieldName} is missing and required. Please add it in.
    </div>
    <div>
      <input
        className={styles.input}
        style={{width: "-webkit-fill-available", marginTop: 20}}
        value={value || ""}
        ref={element => (blankNamesInputValidationRef.current = element)}
        onKeyPress={(e) => {
          if (e.key === "Enter" && value?.length !== 0 && !!value?.trim()) {
            let nextStep = skipStepToStep(stepIndex);
            scrollToView(hello.current[nextStep]?.target);
            updateTableDataField(value, element.rowId, element.column);
            setTimeout(() => {
              setJoyDex(nextStep);
            }, 600);
          }
        }}
        onChange={(e) => setValue(e.target.value)}
        autoFocus
      />
    </div>
    <div className={styles.tooltipFooter}>
      <Button
        disabled={false}
        label={"Skip Lead"}
        title={"Skip and do not invite this lead"}
        color={"green"}
        className={styles.buttonSkip}
        onClick={() => {
          updateTableDataField("No", element.rowId, "invite");
          let nextStep = skipStepToStep(stepIndex);
          scrollToView(hello.current[nextStep]?.target);
          setTimeout(() => {
            setJoyDex(nextStep);
          }, 600);
        }}
      />
      <Button
        disabled={value?.length === 0 || !value?.trim()}
        label={`Continue`}
        title={`Click or press the "Enter Key"`}
        className={styles.buttonContinue}
        onClick={() => {
          let nextStep = skipStepToStep(stepIndex);
          scrollToView(hello.current[nextStep]?.target);
          updateTableDataField(value, element.rowId, element.column);
          setTimeout(() => {
            setJoyDex(nextStep);
          }, 600);
        }}
      />
    </div>
  </div>
}

export const FixDataWizard = (props: Props) => {
  const {dataToClean, updateTableDataField, setTourEnd, dataSource} = props;
  const [dataCleanSteps, setDataCleanSteps] = useState<Step[]>([]);
  const [joyDex, setJoyDex] = useState<number>(0);
  const allInputRefs: any = useRef({});
  const hello: any = useRef(dataCleanSteps);
  hello.current = dataCleanSteps;

  const skipStepToStep = (currentStepIndex: number) => {
    let nextStepIndex = currentStepIndex + 1;

    for (let i = nextStepIndex; i < hello.current.length; i++) {
      if (dataSource[hello.current[i]?.rowId] && dataSource[hello.current[i]?.rowId]?.invite === "Yes") {
        nextStepIndex = i;
        break;
      } else if (i === hello.current.length - 1) {
        nextStepIndex++;
      }
    }
    return nextStepIndex;
  }

  const Tooltip: React.ElementType<TooltipRenderProps> = (props) => {
    const {
      step,
      tooltipProps,
    } = props;

    return (
      <div {...tooltipProps} className={styles.tooltipBody}>
        {step.title && <div className={styles.tooltipTitle}>{step.title}</div>}
        <div className={styles.tooltipContent}>{step.content}</div>
      </div>
    )
  };

  useEffect(() => {
    if (dataCleanSteps.length === 0) {
      let tempArr: (Step & { rowId: number, columnId: string, fieldValue: string, otherData?: any[] })[] = [];
      let stepIndex = 0;

      if (dataToClean?.checkingFirstName.length > 0) {
        for (let e = 0; e < dataToClean.checkingFirstName.length; e++) {
          let firstName = dataToClean.checkingFirstName[e];

          tempArr.push({
            content: <BlankNames stepIndex={stepIndex} element={firstName} fieldName={"First Name"}
                                 updateTableDataField={updateTableDataField} setJoyDex={setJoyDex} hello={hello}
                                 skipStepToStep={skipStepToStep}/>,
            target: `.firstName-${firstName.rowId}`,
            placement: "auto",
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            rowId: firstName.rowId,
            columnId: firstName.column,
            fieldValue: firstName.fieldValue
          })
          stepIndex++;
        }
      }

      if (dataToClean?.checkingSecondName.length > 0) {
        for (let e = 0; e < dataToClean.checkingSecondName.length; e++) {
          let secondName = dataToClean.checkingSecondName[e];

          tempArr.push({
            content: <BlankNames stepIndex={stepIndex} element={secondName} fieldName={"Second Name"}
                                 updateTableDataField={updateTableDataField} setJoyDex={setJoyDex} hello={hello}
                                 skipStepToStep={skipStepToStep}/>,
            target: `.lastName-${secondName.rowId}`,
            placement: "auto",
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            rowId: secondName.rowId,
            columnId: secondName.column,
            fieldValue: secondName.fieldValue
          })
          stepIndex++;
        }
      }

      if (dataToClean?.checkingEmails.length > 0) {
        for (let e = 0; e < dataToClean.checkingEmails.length; e++) {
          let email = dataToClean.checkingEmails[e];

          tempArr.push({
            content: <EmailValidation stepIndex={stepIndex} element={email} fieldName={"email"}
                                      updateTableDataField={updateTableDataField} setJoyDex={setJoyDex} hello={hello}
                                      skipStepToStep={skipStepToStep}/>,
            target: `.email-${email.rowId}`,
            placement: "auto",
            disableBeacon: true,
            hideCloseButton: true,
            disableOverlayClose: true,
            rowId: email.rowId,
            columnId: email.column,
            fieldValue: email.fieldValue
          })
          stepIndex++;
        }
      }
      setDataCleanSteps(tempArr);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataToClean, dataCleanSteps.length, updateTableDataField])

  return (
    <Joyride
      tooltipComponent={Tooltip}
      run={dataCleanSteps?.length >= 1}
      stepIndex={joyDex}
      continuous={true}
      disableOverlay={false}
      disableCloseOnEsc={true}
      callback={(tour) => {
        setTimeout(() => {
          if (allInputRefs.current[tour.index]) allInputRefs.current[tour.index].focus();
        }, 300);
        if (tour.type === EVENTS.TOUR_END) {
          setTourEnd(false);
        }
      }}
      steps={dataCleanSteps}
      styles={{
        options: {
          primaryColor: '#FFB073',
          textColor: 'rgb(39, 70, 73)'
        }
      }}
    />
  );
}
